var map = {
	"./apple-laurel-da-DK.svg": 61715,
	"./apple-laurel-de-DE.svg": 51441,
	"./apple-laurel-en-GB.svg": 18075,
	"./apple-laurel-en-US.svg": 89108,
	"./apple-laurel-es-ES.svg": 17763,
	"./apple-laurel-es-MX.svg": 79536,
	"./apple-laurel-fr-FR.svg": 88903,
	"./apple-laurel-it-IT.svg": 19849,
	"./apple-laurel-nb-NO.svg": 63194,
	"./apple-laurel-nl-NL.svg": 95679,
	"./apple-laurel-pl-PL.svg": 6499,
	"./apple-laurel-pt-BR.svg": 86011,
	"./apple-laurel-pt-PT.svg": 63427,
	"./apple-laurel-sv-SE.svg": 37986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;